export default __webpack_public_path__ + "static/snekker-fd27e182afce4ca0cfcb5297f4113cbb.jpg";